import CareersAreaArdpInterview from "../Components/CareersAreaArdpInterview";

import { Helmet } from "react-helmet-async";

function CareersAreaArdpInterviewContainer() {
  return (
    <>
      <Helmet>
        <title>
          NISSAN MOTOR CORPORATION - GLOBAL CAREER WEBSITE - CAREER AREAS -
          OVERVIEW
        </title>
      </Helmet>
      <main className="career-area-container career-area-details-container">
        <CareersAreaArdpInterview />
      </main>
    </>
  );
}

export default CareersAreaArdpInterviewContainer;
